export default __webpack_public_path__ + "static/media/center_icon.32d4becc.svg";